'use strict';

const $ = require('jquery');
const Slide = require('./slide');
const lang = require('../lang');
const template = require('../templates/done-slide.hbs');
const ControlQuestion = require('./control-question-slide');

module.exports = class extends Slide {
  constructor(context = {}) {
    super(template, context);

    this._timer = 20;
    this._intervalHandler = -1;

    this.on('beforeEnter', this._renderName);
    this.on('beforeEnter', this._countdown);
    this.on('beforeLeave', this._cancelCountdown);
    this.on('beforeLeave', this._clearForm);
  }

  reset() {

  }

  // SLIDE EVENTS

  _renderName() {
    const name = this._slideshow.getFormData().form_field_name;
    this.$el.find('#done-title').html(lang.get('done_title', {name: name}));
  }

  _countdown() {
    const $domTimer = this.$el.find('#done-timer');
    let countdown = this._timer;

    $domTimer.html(countdown);
    this._intervalHandler = setInterval(() => {
      countdown -= 1;
      $domTimer.html(countdown);
      if (countdown === 0) {
        $('#modal').modal('hide');
        window.location.hash = '/';
        clearInterval(this._intervalHandler);
      }
    }, 1000);
  }

  _cancelCountdown() {
    clearInterval(this._intervalHandler);
  }

  _clearForm() {
    document.getElementById("form_field_id_scan").value = "";
    var fieldarr = this._slideshow._setFormLabel();
    $.each(fieldarr, function (key, data) {
      data['value'] = undefined;
    });
    document.getElementById("formfieldlabelform").reset();
    $("#label_exist_code").val('0');
    var sublocid = this._slideshow.getSublocationId();
    if(sublocid != null || sublocid != undefined) {
      for (let i = this._slideshow.slides.length - 1; i >= 0; i--) {
        const slide = this._slideshow.slides[i];
        if (slide instanceof ControlQuestion)
        this._slideshow.remove(i);
    }
  }
  }
};
